import React from 'react';
import {
  UsersIcon,
  ShieldCheckIcon,
  UserGroupIcon,
  WrenchScrewdriverIcon,
  CalendarIcon,
  ClipboardDocumentListIcon,
  BellIcon,
  UserIcon,
} from '@heroicons/react/24/outline';

const StatisticsCards = ({
  users,
  adminUsers,
  groups,
  crews,
  trainingSessions = [],
  autoplannerTasks = [],
  notificationLogs = [],
}) => {
  // Calculate active users (users who are not deactivated)
  const activeUsers = users.filter((user) => user.is_active !== false);

  return (
    <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
      {/* Row 1 */}
      <div className="rounded-lg border border-gray-200 bg-white p-4 shadow-sm">
        <div className="flex items-center">
          <div className="flex-shrink-0">
            <UsersIcon className="h-8 w-8 text-blue-600" />
          </div>
          <div className="ml-4">
            <p className="text-sm font-medium text-gray-500">Total Users</p>
            <p className="text-2xl font-semibold text-gray-900">{users.length}</p>
          </div>
        </div>
      </div>

      <div className="rounded-lg border border-gray-200 bg-white p-4 shadow-sm">
        <div className="flex items-center">
          <div className="flex-shrink-0">
            <UserIcon className="h-8 w-8 text-emerald-600" />
          </div>
          <div className="ml-4">
            <p className="text-sm font-medium text-gray-500">Active Users</p>
            <p className="text-2xl font-semibold text-gray-900">{activeUsers.length}</p>
          </div>
        </div>
      </div>

      <div className="rounded-lg border border-gray-200 bg-white p-4 shadow-sm">
        <div className="flex items-center">
          <div className="flex-shrink-0">
            <ShieldCheckIcon className="h-8 w-8 text-purple-600" />
          </div>
          <div className="ml-4">
            <p className="text-sm font-medium text-gray-500">Administrators</p>
            <p className="text-2xl font-semibold text-gray-900">{adminUsers.length}</p>
          </div>
        </div>
      </div>

      <div className="rounded-lg border border-gray-200 bg-white p-4 shadow-sm">
        <div className="flex items-center">
          <div className="flex-shrink-0">
            <UserGroupIcon className="h-8 w-8 text-green-600" />
          </div>
          <div className="ml-4">
            <p className="text-sm font-medium text-gray-500">Training Groups</p>
            <p className="text-2xl font-semibold text-gray-900">{groups.length}</p>
          </div>
        </div>
      </div>

      {/* Row 2 */}
      <div className="rounded-lg border border-gray-200 bg-white p-4 shadow-sm">
        <div className="flex items-center">
          <div className="flex-shrink-0">
            <WrenchScrewdriverIcon className="h-8 w-8 text-indigo-600" />
          </div>
          <div className="ml-4">
            <p className="text-sm font-medium text-gray-500">Crews</p>
            <p className="text-2xl font-semibold text-gray-900">{crews.length}</p>
          </div>
        </div>
      </div>

      <div className="rounded-lg border border-gray-200 bg-white p-4 shadow-sm">
        <div className="flex items-center">
          <div className="flex-shrink-0">
            <CalendarIcon className="h-8 w-8 text-orange-600" />
          </div>
          <div className="ml-4">
            <p className="text-sm font-medium text-gray-500">Training Sessions</p>
            <p className="text-2xl font-semibold text-gray-900">{trainingSessions.length}</p>
          </div>
        </div>
      </div>

      <div className="rounded-lg border border-gray-200 bg-white p-4 shadow-sm">
        <div className="flex items-center">
          <div className="flex-shrink-0">
            <ClipboardDocumentListIcon className="h-8 w-8 text-teal-600" />
          </div>
          <div className="ml-4">
            <p className="text-sm font-medium text-gray-500">Autoplanner Tasks</p>
            <p className="text-2xl font-semibold text-gray-900">{autoplannerTasks.length}</p>
          </div>
        </div>
      </div>

      <div className="rounded-lg border border-gray-200 bg-white p-4 shadow-sm">
        <div className="flex items-center">
          <div className="flex-shrink-0">
            <BellIcon className="h-8 w-8 text-red-600" />
          </div>
          <div className="ml-4">
            <p className="text-sm font-medium text-gray-500">Notifications Sent</p>
            <p className="text-2xl font-semibold text-gray-900">{notificationLogs.length}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatisticsCards;
